<template>
  <div id="main">
    <div id="user">
      <!-- Home content here -->
      <!-- <NavComponents/> -->
    </div>
 </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>

<style scoped>

</style>